import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app/global.css'; // 👈 match the "tailwind.css" path in your config

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
      <App />
    </React.StrictMode>
);
